/**
 * @file Re-exports the distribution schedule form and its next-recurrence-date helper.
 */
import DistributionsScheduleForm from "./DistributionsScheduleForm";

export { default as getNextRecurrenceDate } from "./helpers/getNextRecurrenceDate";
export default DistributionsScheduleForm;
